/**
 * True when focus moved to an element outside every given container (the select and its menu).
 *
 * A null `next` means focus went nowhere focusable — e.g. a click on the menu's padding — so it
 * returns false and leaves that case to the ClickAwayListener. The menu can be portaled out of
 * the select's DOM, so the caller passes both containers.
 */
export function focusLeftDropdown(next: Node | null, containers: Array<Node | null | undefined>): boolean {
  if (!next) {
    return false
  }
  return !containers.some((container) => container?.contains(next))
}
